"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialTypeHelpers = exports.CredentialType = void 0;
var CredentialType;
(function (CredentialType) {
    CredentialType["JiraProject"] = "JiraProject";
    CredentialType["FacebookPublicPage"] = "FacebookPublicPage";
})(CredentialType = exports.CredentialType || (exports.CredentialType = {}));
var CredentialTypeHelpers = (function () {
    function CredentialTypeHelpers() {
    }
    CredentialTypeHelpers.isValid = function (value) {
        return CredentialTypeHelpers.all.indexOf(value) >= 0;
    };
    CredentialTypeHelpers.all = [
        CredentialType.JiraProject,
        CredentialType.FacebookPublicPage
    ];
    return CredentialTypeHelpers;
}());
exports.CredentialTypeHelpers = CredentialTypeHelpers;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.octopus2.auth.CredentialType', {
    full: 'net.playq.octopus2.auth.CredentialType',
    short: 'CredentialType',
    package: 'net.playq.octopus2.auth',
    type: irt_1.IntrospectorTypes.Enum,
    options: CredentialTypeHelpers.all
});
//# sourceMappingURL=CredentialType.js.map